import { render, staticRenderFns } from "./productComponent.vue?vue&type=template&id=2dbf4508&scoped=true&"
import script from "./productComponent.vue?vue&type=script&lang=js&"
export * from "./productComponent.vue?vue&type=script&lang=js&"
import style0 from "./productComponent.vue?vue&type=style&index=0&id=2dbf4508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbf4508",
  null
  
)

export default component.exports